import request from "@/utils/request";

//退出登录
export function userLoginOut() {
    return request({
        url: '/user/logout',
        method: 'get',
    })
}

//获取信息
export function getProfile() {
    return request({
        url: '/user/profile',
        method: 'get',
    })
}

//获取实时用户信息
export function getMineInfo() {
    return request({
        url: '/user/info',
        method: 'get',
    })
}

//修改手机号
export function updateUserPhone(data) {
    return request({
        url: '/user/updatePhone',
        method: 'post',
        data
    })
}

//获取绑定邮箱的验证码
export function getUserEmailBindCode(email, type) {
    return request({
        url: `/user/email/code/${email}/${type}`,
        method: 'get',
    })
}

//绑定邮箱
export function bindUserEmail(data) {
    return request({
        url: '/user/email/bind',
        method: 'post',
        data
    })
}

//获取修改邮箱的验证码
export function verifyOldEmail(code) {
    return request({
        url: '/user/email/verifyOldEmail/' + code,
        method: 'get',
    })
}

//修改用户密码
export function updateUserPassword(data) {
    return request({
        url: '/user/updatePwd',
        method: 'post',
        data
    })
}
